const createDataDogApm = require('./processor');
const { BLAZE_DATADOG_APM_UI_SERVICES } = require('../constants');

const services = process.env.BLAZE_DATADOG_APM_UI_SERVICES || BLAZE_DATADOG_APM_UI_SERVICES;
const apm = createDataDogApm({ options: { services } });

module.exports = apm;
